import { z } from "zod"

export const baseParameterSchema = z.object({
    id: z.string(),
});

export const configurationParameterSchema = baseParameterSchema.extend({
    name: z.string(),
    settings: z.object({
        isPrivate: z.boolean().optional(),
        isRequiredForExport: z.boolean().optional(),
    }).optional(),
})

export const selectedConfigurationParameterSchema = baseParameterSchema.extend({
    value: z.string(),
})

export const parameterDataSchema = z.object({
    key: z.string(),
    value: z.string()
})

export const fullParameterDataSchema = baseParameterSchema.extend({
    name: z.string(),
    value: z.string().optional().nullable(),
    settings: z.object({
        isPrivate: z.boolean().optional(),
        isRequiredForExport: z.boolean().optional(),
    }).optional(),
    options: z.array(parameterDataSchema).optional(),
})

export const parameterOptionSchema = z.object({
    key: z.string().optional(),
    value: z.string().min(1, "Required")
})

export const parameterFormParameterSchema = z.object({
    parameter_id: z.string().optional(),
    id: z.string().min(1, "Required"),
    name: z.string().min(1, "Required"),
    options: z.array(parameterOptionSchema).optional(),
})

export const parameterSelectedConfigurationSchema = z.array(z.object({
    id: z.string().optional().nullable(),
    value: z.string().optional().nullable(),
}))
